import React from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'

export const FinancialBreadCrumbs: React.FC<React.ComponentProps<typeof Breadcrumbs>> = ({ ...props }) => {
  const { t } = useTranslation()

  return (
    <Breadcrumbs {...props}>
      <Crumb
        data-testid='crumb-financial-external-invoices'
        key='crumb-financial-external-invoices'
        path='/financial/externalinvoices'
        text={t('Financial.Financial')}
      />
      <Crumb
        data-testid='crumb-financial-external-invoices-view'
        key='crumb-financial-external-invoices-view'
        path='/financial/externalinvoices/view-invoice'
        text={t('externalinvoice.view_invoice')}
      />
      <Crumb
        data-testid='crumb-financial-external-invoices-create-view'
        key='crumb-financial-external-invoices-create-view'
        path='/financial/externalinvoices/create-invoice'
        text={t('externalinvoice.create_invoice')}
      />
    </Breadcrumbs>
  )
}

export default FinancialBreadCrumbs
